// @ts-check
/* global $ LogRocket */
'use_strict';

import './references.ts';

/**
 * Resizes & centers current modal / dialog box
 *
 * @returns {void}
 */
export function resize_last_dialog() {
    const dialog = $.ceDialog('get_last')[0];
    if (dialog) {
        const last_dialog = $.ceDialog('get_last');
        last_dialog.ceDialog('resize');
        last_dialog.dialog('option', 'position', last_dialog.dialog('option', 'position'));
    }
}

/**
 * Sends error msg to any third party error report services we use such as bugsnag and logrocket.
 *
 * @param {string} error_msg to send to error reporting services.
 * @returns {void}
 */
export function send_third_party_error_notification(error_msg) {
    // LogRocket loads after window load and is off on some pages, so the global may not exist yet.
    if (typeof LogRocket !== 'undefined') {
        LogRocket.captureMessage(error_msg, {
            tags: {
                level: 'error',
                url: window.location.href
            }
        });
    }

    if (window.bugsnagClient) {
        window.bugsnagClient.notify(new Error(error_msg));
    }
}

/**
 * Gets all data from the inputs within a form element.
 *
 * @param {string} form_name The name attribute (or the beginning of the name) of the form.
 * @returns {object} An object containing all the input values (formatted as input_name: input_value).
 */
export function get_form_data(form_name) {
    const form = document.querySelector(`form[name^="${form_name}"]`);
    const form_data = new FormData(form);
    const data = {};
    for (const field of form_data.entries()) {
        data[field[0]] = field[1];
    }
    return data;
}

/**
 * Generates a string of random hexadecimal characters.
 *
 * @param {number} size The size of the string.
 * @returns {string} A string of random hexadecimal characters.
 */
export function get_random_hex_string(size = 20) {
    const result = [];
    for (let n = 0; n < size; n += 1) {
      result.push(Math.floor(Math.random() * 16).toString(16));
    }

    return result.join('');
}

/**
 * Creates a DOM element using an HTML string.
 * Note: Incompatible with IE11.
 *
 * @param {string} html_string A string of HTML text.
 * @returns {Element | null} The DOM element.
 */
export function html_string_to_element(html_string) {
    const template = document.createElement('template');
    template.innerHTML = html_string.trim();
    return template.content.firstElementChild;
}

export async function load_js_async(url, anonymous, elementType = 'text/javascript') {
    return new Promise((resolve) => {
        const element = document.createElement('script');
        element.src = url;
        element.type = elementType;
        if (anonymous) {
            element.crossOrigin = 'anonymous';
        }
        element.async = true;
        element.onload = () => resolve(true);
        element.onerror = () => resolve(false);
        document.head.appendChild(element);
    });
}
